import React from 'react';
import ReactDOM from 'react-dom';
//REACT-18 BEGIN
// import ReactDOM from "react-dom/client";
//REACT-18 END
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { FlowProvider } from 'flow-react';
import { createStore, applyMiddleware, compose } from 'redux';
import thunk from 'redux-thunk';
import { Provider } from 'react-redux';
import rootReducer from 'store/reducers';
import 'bootstrap/dist/css/bootstrap.css';
import './custom.scss';
import { getApiUrl } from 'helpers/AppHelper';

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const store = createStore(rootReducer, composeEnhancers(
  applyMiddleware(thunk)
));

//REACT-18 BEGIN
// const apiUrl = getApiUrl();
// const root = ReactDOM.createRoot(document.getElementById("root"));
// root.render(
//   <FlowProvider apiurl={apiUrl} config={{ pingtime: 20, throwonfail: false }}>
//     <React.StrictMode>
//       <Provider store={store}>
//         <App />
//       </Provider>
//     </React.StrictMode>
//   </FlowProvider>
// );
//REACT-18 END

ReactDOM.render(
  <FlowProvider apiurl={getApiUrl()} config={{ pingtime: 20, throwonfail: false }}>
    <React.StrictMode>
      <Provider store={store}>
        <App />
      </Provider>
    </React.StrictMode>
  </FlowProvider>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
